/**
 * Datos del negocio.
 *
 * Alimenta /sobre-omega, el footer y el schema LocalBusiness. Están en un
 * solo archivo para que la página y los datos estructurados no puedan
 * contradecirse: si la web dice que se emite factura y el schema no, Google
 * ve una cosa y el cliente otra.
 */

export const ESTUDIO = {
  nombre: "Omega Digital",
  ciudad: "Santiago",
  region: "Región Metropolitana",
  pais: "Chile",

  /**
   * Dos modalidades y nada más: el evento se cubre donde ocurre y la sesión
   * se hace en estudio. La dirección del estudio no se publica; se envía por
   * WhatsApp al confirmar la fecha.
   */
  modalidad: "eventos-y-estudio",
  cobertura: [
    "Santiago y toda la Región Metropolitana",
    "Regiones con recargo de traslado, a convenir",
  ],

  /**
   * Las dos sedes donde se dispara en estudio.
   *
   * Por comuna y sin calle, a propósito: la dirección exacta se manda por
   * WhatsApp al confirmar la fecha — es lo que responde la FAQ del servicio de
   * estudio, y las dos cosas salen de aquí para que no puedan contradecirse.
   */
  sedes: ["La Florida", "Santiago Centro"],
  comunasDestacadas: [
    "Providencia",
    "Las Condes",
    "Vitacura",
    "Ñuñoa",
    "Santiago Centro",
    "La Reina",
  ],

  /* Requisito de compra para una empresa: si no puedes facturar, no te compra. */
  emiteFactura: true,

  whatsapp: "56946195159",
  telefonoDisplay: "+56 9 4619 5159",
  email: "ventas@omegadigitalchile.cl",

  /**
   * Redes propias de Omega. Alimentan el footer y el `sameAs` del schema:
   * para un estudio de fotografía Instagram es el portafolio vivo.
   */
  instagram: "https://www.instagram.com/omegadigital_chile/",
  facebook: "https://www.facebook.com/profile.php?id=61581598505566",

  horario: {
    dias: "Lunes a viernes",
    desde: "09:00",
    hasta: "19:00",
    nota: "Eventos y coberturas de fin de semana, a convenir.",
  },
};

/** Nombre + ciudad, para titulares y schema. */
export const ESTUDIO_UBICACION = `${ESTUDIO.ciudad}, ${ESTUDIO.pais}`;

/** Pasos reales, en secuencia. */
export const PROCESO = [
  {
    title: "Nos escribes",
    copy: "WhatsApp o el formulario. Dices si es un evento, una boda o una sesión en estudio, cuántas horas y para qué fecha.",
  },
  {
    title: "Hacemos las fotos",
    copy: "Al evento vamos nosotros, con la iluminación. La sesión se hace en el estudio, con fondo y luz ya montados.",
  },
  {
    title: "Entregamos editadas",
    copy: "Alta resolución y versión web. El plazo va publicado en cada servicio. Factura incluida.",
  },
];
